import * as React from "react";
import * as fp from "lodash/fp";
import * as storage from "modules/utilities/storage";

export default fp.curry((propToConnect, defaultValue, Component) => class extends React.Component<any, any> {
    unsubscribe = fp.noop;

    componentDidMount() {
        this.unsubscribe = storage.onStorageChange(propToConnect, () => this.forceUpdate())
    };

    componentWillUnmount() {
        this.unsubscribe();
    };

    render() {
        return <Component {...this.props} {...{[propToConnect]: storage.get(propToConnect, defaultValue)}} />
    };
});



// WEBPACK FOOTER //
// ./resources/modules/utils/connectToStorage.tsx